import { render, staticRenderFns } from "./PagamentoBaixa.vue?vue&type=template&id=a1cbbea4"
import script from "./PagamentoBaixa.vue?vue&type=script&lang=js"
export * from "./PagamentoBaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports